export function waitForGa4ClientId(timeout = 3000): Promise<string | undefined> {
    return new Promise((resolve) => {
        const start = Date.now()
        function check() {
            if (window.ga4ClientId) {
                resolve(window.ga4ClientId)
            } else if (Date.now() - start > timeout) {
                console.log("time out ga4ClientId")
                resolve(undefined) // 超时
            } else {
                setTimeout(check, 100)
            }
        }
        check()
    })
}

export function setGa4ClientIdToStorage(clientId: string) {
    try {
        localStorage.setItem("adc-id", clientId)
    } catch (e) {
        console.log(e)
    }
}

export function getGa4ClientIdFromStorage(): string | null {
    try {
        return localStorage.getItem("adc-id")
    } catch (e) {
        return null
    }
}

export async function getCachedGa4ClientId(timeout = 3000): Promise<string | undefined> {
    const cached = getGa4ClientIdFromStorage()
    if (cached) return cached
    const clientId = await waitForGa4ClientId(timeout)
    if (clientId) setGa4ClientIdToStorage(clientId)
    return clientId
}
